import { render, staticRenderFns } from "./CustomizingDefaultRows.vue?vue&type=template&id=3ff71051&"
import script from "./CustomizingDefaultRows.vue?vue&type=script&lang=js&"
export * from "./CustomizingDefaultRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports